<script>
  import { onMount, tick } from 'svelte'
  import { urlParams, tree } from '../base/store'
  let endPoint
  let cities=[], districts=[]//, estates=[]
  let city, district//, estate
  let breadcrumbs, title, imageUrl
  const setHeader = () => {
    breadcrumbs = $tree.filter(x => endPoint.indexOf(x.url) > -1).sort((a, b) => b.url.length - a.url.length)
    title = (breadcrumbs[0] || {}).title;
    imageUrl = (breadcrumbs.filter(x => !!x.image_url)[0] || {}).image_url;
    document.querySelector('.header-text h1').innerHTML = title
    document.querySelector('header').style.backgroundImage = `url(${imageUrl})`
  }
  const set = () => {
    cities = $tree.filter(x => x.content_type__model === "city");
    city = (cities.filter(x => endPoint.indexOf(x.url) > -1)[0] || {}).url || "";
    districts = $tree.filter(x => x.content_type__model === "district" && x.url.indexOf(city) > -1);
    district = (districts.filter(x => endPoint.indexOf(x.url) > -1)[0] || {}).url || city;
    /*estates = $tree.filter(x => x.content_type__model === "estate" && (
      (x.url.indexOf(city) > -1) || (district && (x.url.indexOf(district) > -1))));
    estate = (estates.filter(x => endPoint.indexOf(x.url) > -1)[0] || {}).url || city;*/
    setHeader();
  }
  onMount(() => {
    const { pathname } = window.location
    endPoint = decodeURIComponent(pathname.replace('/catalog/', ''))
    tree.update(state => state.map(x => ({
      ...x, url: x.url_path.replace("/home/catalog/", "") })))
    set()
  })
// Handlers
  const handle = async e => {
    endPoint = e.target.value
    await urlParams.applyFilters({ redirect: endPoint })
    set()
  }
</script>

<div class="input-wrapper">
  <label for="strict">Город</label>
  <select name="strict" id="strict" aria-placeholder="Выбрать" on:change={handle} bind:value={city}>
    <option value="" selected>--Все--</option>
    {#each cities as city}
      <option value="{city.url}">{city.title}</option>
    {/each}
  </select>
</div>
<div class="input-wrapper">
  <label for="strict">Район</label>
  <select name="strict" id="strict" aria-placeholder="Выбрать" on:change={handle} bind:value={district}>
    <option value={city} selected>--Все--</option>
    {#each districts as district}
      <option value="{district.url}">{district.title}</option>
    {/each}
  </select>
</div>
<!--<div class="input-wrapper">
  <label for="street">Жилой комплекс</label>
  <select name="street" id="street" aria-placeholder="Выбрать" on:change={handle} bind:value={estate}>
    <option value={city} selected>--Все--</option>
    {#each estates as estate}
      <option value="{estate.url}">{estate.title}</option>
    {/each}
  </select>
</div>-->
